export class PointIncrement {
    constructor(public incrementX: number,
                public incrementY: number){
    }
}